export const STRINGS = {
  rekeyingSpotCleaningDisclaimerTitle: 'After Your Home Is Loved',
  copyTemplates: {
    openingPhrases: {
      bothServices:
        'In order to ensure a delightful and safe move‑in experience, ',
      cleaningOnly: 'In order to ensure a delightful move-in experience, ',
      securityOnly:
        'For your safety, and the safety of your future Residents, ',
    },
    belongIntro: 'Belong also ',
    cleaningDescriptions: {
      spotCleaning:
        'performs a surface-level cleaning before new Residents arrive',
      deepCleaning: 'performs a deep cleaning before new Residents arrive',
    },
    connectors: {
      bothServices: ', and ',
      cleaningOnly: '. ',
    },
    securityDescriptions: {
      rekeying:
        'rekeys every Home during each period of vacancy, ensuring only Belong and your new Residents have access. ',
      recoding:
        'recodes every Home with keyless entry during each period of vacancy, ensuring only Belong and your new Residents have access. ',
    },
    costTemplate:
      "The total cost for {thisThese} will be {totalPrice}, and you'll see {thisThese} in your account once we've found Residents to love your Home.",
  },
};
